// extracted by mini-css-extract-plugin
export var copyableField = "_pk-4";
export var customerBadge = "_pk-0";
export var customerInfoTitle = "_pk-2";
export var details = "_pk-1";
export var dropdownContainer = "_pk-5";
export var dropdownImage = "_pk-6";
export var editAssigneeForm = "_pk-a";
export var editButton = "_pk-3";
export var email = "_pk-7";
export var hidden = "_pk-d";
export var input = "_pk-8";
export var saveButton = "_pk-b";
export var shopifyIcon = "_pk-c";
export var suggestionBadge = "_pk-e";
export var suggestionText = "_pk-f";
export var username = "_pk-9";